import { render, staticRenderFns } from "./BnfcrInfoApp.vue?vue&type=template&id=4bd4e941&"
import script from "./BnfcrInfoApp.vue?vue&type=script&lang=js&"
export * from "./BnfcrInfoApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports